(function($) {

/*
Map style
http://www.mapstylr.com/style/blue-white-3/
*/



/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/

function new_map( $el ) {

	// var
	var $markers = $el.find('.marker');


	var styledMapType = new google.maps.StyledMapType([
	    {
	        "featureType": "administrative.country",
	        "elementType": "all",
	        "stylers": [
	            {
	                "visibility": "on"
	            },
	            {
	                "color": "#ffffff"
	            },
	            {
	                "weight": 1
	            }
	        ]
	    },
	    {
	        "featureType": "administrative",
	        "elementType": "all",
	        "stylers": [
	            {
	                "visibility": "on"
	            },
	            {
	                "hue": "#00517a"
	            },
	            {
	                "saturation": 100
	            }
	        ]
	    },
	    {
	        "featureType": "administrative.province",
	        "elementType": "all",
	        "stylers": [
	            {
	                "visibility": "on"
	            },
	            {
	                "saturation": -100
	            }
	        ]
	    },
	    {
	        "featureType": "landscape.natural",
	        "elementType": "all",
	        "stylers": [
	            {
	                "visibility": "on"
	            }
	        ]
	    },
	    {
	        "featureType": "landscape.man_made",
	        "elementType": "all",
	        "stylers": [
	            {
	                "visibility": "on"
	            }
	        ]
	    },
	    {
	        "featureType": "poi",
	        "elementType": "all",
	        "stylers": [
	            {
	                "visibility": "off"
	            }
	        ]
	    },
	    {
	        "featureType": "landscape",
	        "elementType": "all",
	        "stylers": [
	            {
	                "visibility": "on"
	            },
	            {
	                "color": "#ffffff"
	            }
	        ]
	    },
	    {
	        "featureType": "water",
	        "elementType": "all",
	        "stylers": [
	            {
	                "color": "#41b7e6"
	            }
	        ]
	    },
	    {
	        "featureType": "administrative.country",
	        "elementType": "geometry.stroke",
	        "stylers": [
	            {
	                "visibility": "on"
	            },
	            {
	                "color": "#aaaaaa"
	            },
	            {
	                "lightness": -6
	            }
	        ]
	    },
	    {
	        "featureType": "road",
	        "elementType": "geometry.stroke",
	        "stylers": [
	            {
	                "visibility": "simplified"
	            }
	        ]
	    },
	    {
	        "featureType": "road",
	        "elementType": "geometry.fill",
	        "stylers": [
	            {
	                "weight": 2.07
	            },
	            {
	                "hue": "#ed8a00"
	            },
	            {
	                "gamma": 2.5
	            }
	        ]
	    },
	    {
	        "featureType": "administrative",
	        "elementType": "labels.text.stroke",
	        "stylers": [
	            {
	                "color": "#ffffff"
	            }
	        ]
	    }
	],
	{name: 'Styled Map'});


	// vars
	var args = {
		zoom		: 4,
		center		: new google.maps.LatLng(58.74535592876386, -98.38267812499998),
		mapTypeControlOptions: {
            mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain',
                    'styled_map']
          }
	};


	// create map
	var map = new google.maps.Map( $el[0], args);

	//Associate the styled map with the MapTypeId and set it to display.
	map.mapTypes.set('styled_map', styledMapType);
    map.setMapTypeId('styled_map');

	// add a markers reference
	map.markers = [];


	// add markers
	$markers.each(function(){

    	add_marker( $(this), map );

	});

	//initialize map pin
	var legend = document.getElementById('legend');

	var colors = [
		[ '#CB2C30', 'Project' ],
		[ '#7474c1', 'Innovation' ],
		[ '#ED8B00', 'Event' ],
	];

	var iconBase = 'https://canadianinnovationspace.ca/wp-content/themes/cis/assets/dist/img/';

	for ( var i = 0; i < colors.length; i++ ) {
		var div = document.createElement('div');
		var icon = iconBase + colors[i][1] + '-pin.png';

		div.innerHTML = '<img src="' + icon + '">' + colors[i][1];


		if ( legend != null )
			legend.appendChild(div);
	}

	map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(legend);

	// center map
	//center_map( map );


	// return
	return map;

}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker( $marker, map ) {

	// var
	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

	var mapPin = {

	    path: "M8,0 C3.58263869,0 0,3.65802368 0,8.16833401 C0,10.0114332 0.597872952,11.7136586 1.60735844,13.0801347 L8,23 L14.5283127,12.8876072 C15.4550158,11.5563495 16,9.92690894 16,8.16833401 C16,3.65802368 12.4173613,0 8,0 Z",
	    fillOpacity: 1,
	    anchor: new google.maps.Point(8,23),
	    strokeWeight: 1,
	    strokeColor: "#FFFFFF",
	    scale: 1
	}

	if ( $marker.data('type') == 'project' )
		mapPin.fillColor = '#CB2C30';
	else if ( $marker.data('type') == 'innovation' )
		mapPin.fillColor = '#7474c1';
	else if ( $marker.data('type') == 'event' )
		mapPin.fillColor = '#ED8B00';

	// create marker
	var marker = new google.maps.Marker({
		position	: latlng,
		map			: map,
		icon 		: mapPin
	});

	// add to array
	map.markers.push( marker );

	// if marker contains HTML, add it to an infoWindow
	if( $marker.html() )
	{
		// create info window
		var infowindow = new google.maps.InfoWindow({
			content		: $marker.html()
		});

		// show info window when marker is clicked
		google.maps.event.addListener(marker, 'click', function() {

			infowindow.open( map, marker );

		});
	}

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map( map ) {

	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){

		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

		bounds.extend( latlng );

	});

	// only 1 marker?
	if( map.markers.length == 1 )
	{
		// set center of map
	    map.setCenter( bounds.getCenter() );
	    map.setZoom( 16 );
	}
	else
	{
		// fit to bounds
		map.fitBounds( bounds );
	}

}

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/
// global var
var map = null;

$(document).ready(function(){

	$('.projects-map').each(function(){

		// create map
		map = new_map( $(this) );

	});

});

})(jQuery);
